import React, { useEffect, useState } from "react";
import "./blog.scss";
import { Link, useNavigate } from "react-router-dom";
import { useBlog } from "../../hooks/blog/useBlog";
import Loader from "../../hooks/loader";
import Pagination from "react-bootstrap/Pagination";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
const Blog = () => {
  const [show, setShow] = useState(false);
  const [mostRecentCategory, setMostRecentCategory] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate();

  const {
    // States
    blogs,
    categories,
    selectedCategories, // Now an array
    error,
    loading,
    // Functions
    fetchAllBlogs,
    fetchBlogsByCategory,
    fetchAllCategories,
    setSelectedCategories, // Now sets an array
  } = useBlog();

  const [featuredBlog, setFeaturedBlog] = useState(null);
  const [localLoading, setLocalLoading] = useState(true);
  const [displayBlogs, setDisplayBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [blogsPerPage] = useState(6); // Adjust as needed

  // Initial data fetch
  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchInitialData = async () => {
      setLocalLoading(true);
      try {
        // Load categories first
        await fetchAllCategories();
        // Then load blogs
        await fetchAllBlogs();
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setLocalLoading(false);
      }
    };

    fetchInitialData();
  }, []);



// handleCategoryChange function
const handleCategoryChange = async (categoryId) => {
  setLocalLoading(true);

  let newSelectedCategories;

  if (categoryId === null) {
    // If "All Categories" is selected, clear all selections
    newSelectedCategories = [];
    setMostRecentCategory(null); // Reset most recent category
  } else {
    // Check if category is already selected
    if (selectedCategories.includes(categoryId)) {
      // If already selected, remove it
      newSelectedCategories = selectedCategories.filter(
        (id) => id !== categoryId
      );
      // If we're removing the most recent category, set most recent to the last one in the array
      if (mostRecentCategory === categoryId) {
        setMostRecentCategory(
          newSelectedCategories.length > 0 
            ? newSelectedCategories[newSelectedCategories.length - 1] 
            : null
        );
      }
    } else {
      // If not selected, add it
      newSelectedCategories = [...selectedCategories, categoryId];
      // Set this as the most recent category
      setMostRecentCategory(categoryId);
    }
  }

  // selected categories
  setSelectedCategories(newSelectedCategories);

  try {
    if (newSelectedCategories.length === 0) {
      // If no categories selected, fetch all blogs
      await fetchAllBlogs();
    } else {
      // Fetch blogs by selected categories
      await fetchBlogsByCategory(newSelectedCategories.join(","));
    }
  } catch (error) {
    console.error("Error changing category:", error);
  } finally {
    setLocalLoading(false);
  }
};

// useEffect that sets the featured blog
useEffect(() => {
  if (blogs && blogs.length > 0) {
    // If no categories are selected or most recent category is null, use the first blog as featured
    if (selectedCategories.length === 0 || mostRecentCategory === null) {
      setFeaturedBlog(blogs[0]);
      setDisplayBlogs(blogs.slice(1));
    } else {
      // Find the first blog that belongs to the most recent category
      const featuredFromRecentCategory = blogs.find(blog => 
        blog.categories && blog.categories.includes(mostRecentCategory)
      );
      
      if (featuredFromRecentCategory) {
        setFeaturedBlog(featuredFromRecentCategory);
        // Filter out the featured blog from the display list
        setDisplayBlogs(blogs.filter(blog => blog.id !== featuredFromRecentCategory.id));
      } else {
        // Fallback to the first blog if none found from the recent category
        setFeaturedBlog(blogs[0]);
        setDisplayBlogs(blogs.slice(1));
      }
    }
  }
}, [blogs, selectedCategories, mostRecentCategory]);


  // Function to strip HTML tags from content
  const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  // Function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // Get category names for display
  const getSelectedCategoriesText = () => {
    if (selectedCategories.length === 0) return "All Categories";
    if (selectedCategories.length === 1) {
      const category = categories.find(
        (cat) => cat.id === selectedCategories[0]
      );
      return category ? category.name : "All Categories";
    }
    return `${selectedCategories.length} Categories Selected`;
  };

  // Pagination logic
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = displayBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(displayBlogs.length / blogsPerPage);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      {(localLoading || loading) && <Loader />}

      <section className="blog-section">
        <img
          src="\newbgbg.png"
          className="img-fluid backkgroundimg"
          alt="img"
        />

        {/* Featured Blog - Make entire featured blog clickable */}
        {featuredBlog && (
          <div
            className="main-blog"
            onClick={() => navigate(`/blogdetail/${featuredBlog?.slug}`)}
            style={{ cursor: "pointer" }}
          >
            <h6>{featuredBlog.title.rendered}</h6>
            <p>
              {stripHtml(featuredBlog.excerpt.rendered).substring(0, 200)}...
            </p>
            <div className="main-img">
              <img
                src={
                  featuredBlog.jetpack_featured_media_url ||
                  "/assets/blog/dummymain.png"
                }
                alt={featuredBlog.title.rendered}
                className="img-fluid"
              />
            </div>
          </div>
        )}
        <div className="custom-container">
          <div className="latest-blog">
            <div className="upper-heading">
              <h6>Latest Blogs</h6>
              <div className="dropdown">
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {getSelectedCategoriesText()}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M12 7.5L9 10.5L6 7.5"
                      stroke="#013159"
                      strokeWidth="1.5"
                      strokeLinecap="square"
                    />
                  </svg>
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <li className="formobiledrop d-none">
                    <p>Filter By Categories </p>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleCategoryChange(null);
                      }}
                    >
                      <label className="checkbox" htmlFor="all-categories">
                        <input
                          type="checkbox"
                          name="category"
                          id="all-categories"
                          checked={selectedCategories.length === 0}
                          onChange={() => {}}
                        />
                        <span className="checkmark"></span>
                      </label>
                      All Categories
                    </a>
                  </li>
                  {categories.map((category) => (
                    <li key={category.id}>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleCategoryChange(category.id);
                        }}
                      >
                        <label
                          className="checkbox"
                          htmlFor={`category-${category.id}`}
                        >
                          <input
                            type="checkbox"
                            name="category"
                            id={`category-${category.id}`}
                            checked={selectedCategories.includes(category.id)}
                            onChange={() => handleCategoryChange(category.id)}
                          />
                          <span className="checkmark"></span>
                        </label>
                        {category.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="formobileoffcan d-none">
                <button className="innerbtnoff" onClick={handleShow}>
                  All Categories{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M12 7.5L9 10.5L6 7.5"
                      stroke="#013159"
                      strokeWidth="1.5"
                      strokeLinecap="square"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="bottom-cards">
              {currentBlogs.length > 0 &&
                currentBlogs.map((blog) => (
                  <div
                    onClick={() => navigate(`/blogdetail/${blog?.slug}`)}
                    className="single-card"
                    key={blog.id}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="main-img">
                      <img
                        src={
                          blog.jetpack_featured_media_url ||
                          "/assets/blog/dummymain.png"
                        }
                        alt={blog.title.rendered}
                        className="img-fluid"
                      />
                    </div>
                    <div className="bottom-detail">
                      <div className="titletext">
                        <h6>{blog.title.rendered}</h6>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                        >
                          <path
                            d="M22.1973 10.2806L17.6973 14.7806C17.5565 14.9214 17.3656 15.0004 17.1666 15.0004C16.9676 15.0004 16.7767 14.9214 16.636 14.7806C16.4953 14.6399 16.4162 14.449 16.4162 14.25C16.4162 14.051 16.4953 13.8601 16.636 13.7194L19.8563 10.5H16.1354C14.306 10.4995 12.5283 11.107 11.0819 12.2271C9.63551 13.3472 8.60241 14.9162 8.14506 16.6875C8.09534 16.8802 7.9711 17.0453 7.79968 17.1463C7.62826 17.2474 7.4237 17.2763 7.231 17.2266C7.0383 17.1768 6.87326 17.0526 6.77216 16.8812C6.67107 16.7098 6.64221 16.5052 6.69194 16.3125C7.23158 14.2186 8.45234 12.3637 10.162 11.0398C11.8716 9.71598 13.9731 8.99836 16.1354 9H19.8582L16.636 5.78063C16.5663 5.71095 16.511 5.62822 16.4733 5.53718C16.4356 5.44613 16.4162 5.34855 16.4162 5.25001C16.4162 5.15146 16.4356 5.05388 16.4733 4.96283C16.511 4.87179 16.5663 4.78906 16.636 4.71938C16.7767 4.57865 16.9676 4.49959 17.1666 4.49959C17.2652 4.49959 17.3628 4.519 17.4538 4.55671C17.5448 4.59442 17.6276 4.6497 17.6973 4.71938L22.1973 9.21938C22.267 9.28903 22.3223 9.37175 22.36 9.4628C22.3978 9.55385 22.4172 9.65144 22.4172 9.75C22.4172 9.84857 22.3978 9.94616 22.36 10.0372C22.3223 10.1283 22.267 10.211 22.1973 10.2806ZM18.6666 19.5H4.41663V8.25001C4.41663 8.05109 4.33761 7.86033 4.19696 7.71968C4.0563 7.57902 3.86554 7.50001 3.66663 7.50001C3.46771 7.50001 3.27695 7.57902 3.1363 7.71968C2.99564 7.86033 2.91663 8.05109 2.91663 8.25001V20.25C2.91663 20.4489 2.99564 20.6397 3.1363 20.7803C3.27695 20.921 3.46771 21 3.66663 21H18.6666C18.8655 21 19.0563 20.921 19.197 20.7803C19.3376 20.6397 19.4166 20.4489 19.4166 20.25C19.4166 20.0511 19.3376 19.8603 19.197 19.7197C19.0563 19.579 18.8655 19.5 18.6666 19.5Z"
                            fill="#013159"
                          />
                        </svg>
                      </div>
                      <p className="para">
                        {stripHtml(blog.excerpt.rendered).substring(0, 150)}...
                      </p>
                      <p className="date" style={{ color: "#627F97" }}>
                        {formatDate(blog.date)}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
          {displayBlogs.length > 0 && (
            <div className="mainpagi">
              <div className="mainparent">
                <div className="right">
                  <div
                    className="arrow-container"
                    onClick={() => currentPage > 1 && paginate(currentPage - 1)}
                  >
                    <img
                      src="\arrowsright.png"
                      alt="img"
                      className="img-fluid"
                      style={{
                        cursor: currentPage > 1 ? "pointer" : "default",
                        opacity: currentPage > 1 ? 1 : 0.5,
                        rotate: "180deg",
                      }}
                    />
                  </div>
                  <Pagination>
                    {[...Array(Math.min(totalPages, 7))].map((_, index) => {
                      let pageNumber;

                      // Logic to determine which page numbers to show
                      if (totalPages <= 7) {
                        pageNumber = index + 1;
                      } else if (currentPage <= 4) {
                        if (index < 5) {
                          pageNumber = index + 1;
                        } else if (index === 5) {
                          return <Pagination.Ellipsis key="ellipsis" />;
                        } else {
                          pageNumber = totalPages;
                        }
                      } else if (currentPage >= totalPages - 3) {
                        if (index === 0) {
                          pageNumber = 1;
                        } else if (index === 1) {
                          return <Pagination.Ellipsis key="ellipsis" />;
                        } else {
                          pageNumber = totalPages - (6 - index);
                        }
                      } else {
                        if (index === 0) {
                          pageNumber = 1;
                        } else if (index === 1) {
                          return <Pagination.Ellipsis key="ellipsis-1" />;
                        } else if (index < 5) {
                          pageNumber = currentPage + (index - 3);
                        } else if (index === 5) {
                          return <Pagination.Ellipsis key="ellipsis-2" />;
                        } else {
                          pageNumber = totalPages;
                        }
                      }

                      return (
                        <Pagination.Item
                          key={pageNumber}
                          active={pageNumber === currentPage}
                          onClick={() => paginate(pageNumber)}
                        >
                          {pageNumber}
                        </Pagination.Item>
                      );
                    })}
                  </Pagination>
                  <div
                    className="arrow-container"
                    onClick={() =>
                      currentPage < totalPages && paginate(currentPage + 1)
                    }
                  >
                    <img
                      src="\arrowsright.png"
                      alt="img"
                      className="img-fluid"
                      style={{
                        cursor:
                          currentPage < totalPages ? "pointer" : "default",
                        opacity: currentPage < totalPages ? 1 : 0.5,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="bottom"
        className="mainnnnn"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filter By Categories</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="maincheckkk">
            <div className="inner">
              <div className="checkboxmain">
                <label className="checkbox" htmlFor="mobile-all-categories">
                  <input
                    type="checkbox"
                    name="category"
                    id="mobile-all-categories"
                    checked={selectedCategories.length === 0}
                    onChange={() => handleCategoryChange(null)}
                  />
                  <span className="checkmark"></span>
                </label>
                <p className="checkboxpara">All Categories</p>
              </div>
            </div>

            {categories.map((category) => (
              <div className="inner" key={category.id}>
                <div className="checkboxmain">
                  <label
                    className="checkbox"
                    htmlFor={`mobile-category-${category.id}`}
                  >
                    <input
                      type="checkbox"
                      name="category"
                      id={`mobile-category-${category.id}`}
                      checked={selectedCategories.includes(category.id)}
                      onChange={() => handleCategoryChange(category.id)}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <p className="checkboxpara">{category.name}</p>
                </div>
              </div>
            ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Blog;
